(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('input', focusNavBasic);

    angular
        .module('invesfleet')
        .directive('navigable', focusNavCustom);
        
    angular
        .module('invesfleet')
        .directive('textarea', focusNavBasic);
        /*
    angular
        .module('invesfleet')
        .directive('button', focusNav);
        
    angular
        .module('invesfleet')
        .directive('a', focusNav);*/

    
    var linkFunction = function(scope, element, attrs){
                
        /* KEYCODES
        TAB: 9
        ENTER: 13
        ARROW UP: 38
        ARROW DOWN: 40
        ARROW LEFT: 37
        ARROW RIGHT: 39 */

        element.bind('keydown', function(e) {
            var code = e.keyCode || e.which;
            
            switch(code){
                case 9: //TAB 
                    e.preventDefault();
                    if(event.shiftKey){
                        moveFocusToPrev();
                    }else{
                        moveFocusToNext();
                    }
                    break;
            }
        });
        
        element.bind('keyup', function(e) {

            var code = e.keyCode || e.which;

            switch(code){
                case 13: //ENTER 
                    if (!element[0].classList.contains('searcher-input')) {
                        moveFocusToNextEnter();
                    } else {
                        return true;
                    };              
                    break;
            }
        });

        function moveFocusToPrev(){
            var elements = document.querySelectorAll('input, textarea, [navigable]'); 
            var index = -1;
            var target = null;
            for(var i = 0; i < elements.length; i++){
                if(elements[i] === element[0]){
                    index = i;
                    break;
                }
            }
            if(index > 0 && index < elements.length){
                for(i = index-1; i >= 0; i--){
                    if(elements[i].offsetParent !== null && !elements[i].classList.contains('not-navigable') &&
                        elements[i].getAttribute('type') !== 'checkbox' &&
                        (elements[i].disabled === undefined || elements[i].disabled === false)){
                        target = elements[i];
                        break;
                    }
                }
            }
            if(target){
                target.focus();
            }
        }

        function moveFocusToNext(){
            var elements = document.querySelectorAll('input, textarea, [navigable]');
            var found = false;
            var target = null;
            for(var i = 0; i < elements.length; i++){
                if(found && elements[i].offsetParent !== null && 
                    !elements[i].classList.contains('not-navigable') &&
                    elements[i].getAttribute('type') !== 'checkbox' &&
                    (elements[i].disabled === undefined || elements[i].disabled === false)){
                    target = elements[i];
                    break; 
                }else if(elements[i] === element[0]){
                    found = true;
                }
            }
            if(target){
                target.focus();
            }
        }

        function moveFocusToNextEnter(){
            if(element[0].tagName === 'TEXTAREA'){ return; }

            var elements = document.querySelectorAll('input, textarea, [navigable]');
            var found = false;
            var target = null;
            for(var i = 0; i < elements.length; i++){
                if(found && elements[i].offsetParent !== null && 
                    !elements[i].classList.contains('not-navigable') && 
                    elements[i].getAttribute('type') !== 'checkbox' &&
                    (elements[i].disabled === undefined || elements[i].disabled === false)){
                    target = elements[i];
                    break; 
                }else if(elements[i] === element[0]){
                    found = true;
                }
            }
            if(target){ 
                target.focus();
            }
        }
    };

    focusNavBasic.$inject = [];
    function focusNavBasic() {
        return {
            restrict: 'E',
            scope: false,
            link: linkFunction
        };
    }
    focusNavCustom.$inject = [];
    function focusNavCustom() {
        return {
            restrict: 'A',
            scope: false,
            link: linkFunction
        };
    }

    
})();